const LEGACY_ONBOARDING_KEY = 'onboarding_completed';
const PRIMARY_ONBOARDING_KEY = 'tension_onboarding_complete';

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
}

export function isOnboardingComplete(): boolean {
  if (!canUseStorage()) return false;
  try {
    const primary = localStorage.getItem(PRIMARY_ONBOARDING_KEY) === 'true';
    const legacy = localStorage.getItem(LEGACY_ONBOARDING_KEY) === 'true';
    return primary || legacy;
  } catch {
    return false;
  }
}

export function markOnboardingComplete(): void {
  if (!canUseStorage()) return;
  try {
    localStorage.setItem(PRIMARY_ONBOARDING_KEY, 'true');
    localStorage.setItem(LEGACY_ONBOARDING_KEY, 'true');
    localStorage.setItem('onboarding_completed_at', new Date().toISOString());
  } catch {
    // ignore restricted storage environments
  }
}

export function clearOnboardingComplete(): void {
  if (!canUseStorage()) return;
  try {
    localStorage.removeItem(PRIMARY_ONBOARDING_KEY);
    localStorage.removeItem(LEGACY_ONBOARDING_KEY);
    localStorage.removeItem('onboarding_completed_at');
  } catch {
    // ignore restricted storage environments
  }
}

